import React, { useContext } from "react";

//components
import ClustersViewMobile from "./ClustersViewMobile";
import ClustersViewDesktop from "./ClustersViewDesktop";

//global tate
import { StateContext } from "../../AppStateContext";

//headers array for the displayed info about the cluster
const headers = [
  { name: "Status", align: "left" },
  { name: "Cluster Id", align: "left" },
  { name: "Modules", align: "left" },
  { name: "Tier", align: "left" },
  { name: "Auth", align: "left" },
  // { name: "Dataset", align: "left" },
  { name: "Expires", align: "left" },
  { name: "Connect", align: "left" },
  { name: "Delete", align: "center" },
];

const ClustersListTableContent = ({ clusters, setClusters }) => {
  //consuming global state
  const state = useContext(StateContext);

  return (
    <>
      <ClustersViewDesktop
        setClusters={setClusters}
        clusters={clusters}
        headers={headers}
      />

      <div className="__clusterMobileViewDiv">
        <h3
          style={{ color: state.theme === "dark" ? "#fff" : "#00152b" }}
          className="__weaviateClustersTitleMobile"
        >
          Weaviate Clusters
        </h3>
        {clusters && clusters.data.clusterIDs
          ? clusters.data.clusterIDs.map((cluster, idx) => (
              <ClustersViewMobile
                key={cluster}
                setClusters={setClusters}
                clusters={clusters}
                cluster={cluster}
              />
            ))
          : null}
      </div>
    </>
  );
};

export default ClustersListTableContent;
